import { render, staticRenderFns } from "./u-header-basic.vue?vue&type=template&id=959c03ce&scoped=true"
import script from "./u-header-basic.vue?vue&type=script&lang=js"
export * from "./u-header-basic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "959c03ce",
  null
  
)

export default component.exports